"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doneMessage = exports.aiOnboardingNotSaasMessage = exports.aiOnboardingEmailCompletedMessage = exports.aiOnboardingEmailStartMessage = exports.aiOnboardingCompanyInfoCompletedMessage = exports.aiOnboardingCompanyInfoStartMessage = void 0;
exports.aiOnboardingCompanyInfoStartMessage = "---COMPANY INFO STARTED---";
exports.aiOnboardingCompanyInfoCompletedMessage = "---COMPANY INFO COMPLETED---";
exports.aiOnboardingEmailStartMessage = "---EMAIL START---";
exports.aiOnboardingEmailCompletedMessage = "---EMAIL COMPLETED---";
exports.aiOnboardingNotSaasMessage = "---NOT SAAS---";
exports.doneMessage = "---DONE---";
//# sourceMappingURL=ai_onboarding_helper.js.map